
import { Component, Vue } from 'vue-property-decorator';
import { OsType, getOSType } from '@/util/device';

@Component
export default class Parts extends Vue {
  private get message(): string {
    const title1: string = this.$t('camera.onPermissionDenied.linkTitle1') as string;
    const title2: string = this.$t('camera.onPermissionDenied.linkTitle2') as string;
    const address1: string = this.$t('camera.onPermissionDenied.linkAddress1') as string;
    const address2: string = this.$t('camera.onPermissionDenied.linkAddress2') as string;
    const tag1: string = this.$t('camera.onPermissionDenied.linkTag', { title: title1, address: address1 }) as string;
    const tag2: string = this.$t('camera.onPermissionDenied.linkTag', { title: title2, address: address2 }) as string;

    const osType = getOSType();
    if (osType === OsType.Android) {
      return this.$t('camera.onPermissionDenied.messageAndroid', { tag1, tag2 }) as string;
    } else if (osType === OsType.iOS || osType === OsType.iPad) {
      return this.$t('camera.onPermissionDenied.messageIos', { tag2 }) as string;
    } else {
      return this.$t('camera.onPermissionDenied.message') as string;
    }
  }
}
